import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

const Loader: React.FC = () => {
  const [message, setMessage] = useState("");

  useEffect(() => {
    const startTime = Date.now();

    const interval = setInterval(() => {
      const elapsed = Date.now() - startTime;
      if (elapsed >= 10000) {
        setMessage("Processing your information... Almost there!");
      } else if (elapsed >= 5000) {
        setMessage("Hang tight! We’re getting everything ready for your move-in.");
      }
    }, 0); 

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        top: 0,
        left: 0,
        width: "100%",
        height: "500px",
        backgroundColor: "white",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box sx={{ width: 64, height: 64, mb: 2 }}>
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 88 88"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{
            animation: "spin 1.2s linear infinite",
            transformOrigin: "center",
          }}
        >
          <path
            d="M78.929 64.1665L77.0385 67.1341L74.8965 69.9257L72.5193 72.5199L69.9251 74.897L67.1336 77.039L64.166 78.9296L61.045 80.5543L57.7942 81.9008L54.4384 82.9589L51.0032 83.7205L47.5146 84.1797L43.9993 84.3332L40.4841 84.1797L36.9955 83.7205L33.5603 82.9589L30.2045 81.9008L26.9537 80.5543L23.8327 78.9296L20.8651 77.039L18.0736 74.897L15.4794 72.5199L13.1022 69.9257L10.9602 67.1341L9.06966 64.1665L7.44494 61.0455L6.09841 57.7947L5.04034 54.4389L4.27877 51.0037L3.8195 47.5152L3.66602 43.9999L3.8195 40.4846L4.27877 36.9961L5.04034 33.5608L6.09841 30.2051L7.44494 26.9543L9.06966 23.8332L10.9602 20.8656L13.1022 18.0741L15.4794 15.4799L18.0736 13.1028L20.8651 10.9607L23.8327 9.07019L26.9537 7.44547L30.2045 6.09894L33.5603 5.04087L36.9955 4.2793"
            stroke="#858585"
            strokeOpacity="0.2"
            strokeWidth="4"
            strokeLinecap="round"
          />
          <path
            d="M51.0039 4.2793L54.4391 5.04087L57.7949 6.09894L61.0457 7.44547L64.1668 9.07019L67.1344 10.9607L69.9259 13.1028L72.5201 15.4799L74.8972 18.0741L77.0392 20.8656L78.9298 23.8332L80.5545 26.9543L81.901 30.2051L82.9591 33.5608L83.7207 36.9961L84.18 40.4846L84.3334 43.9999L84.18 47.5152L83.7207 51.0037"
            stroke="#858585"
            strokeWidth="4"
            strokeLinecap="round"
          />
        </svg>
      </Box>

      <Typography
        sx={{
          fontFamily: "sans-serif",
          fontWeight: 700,
          fontSize: "20px",
          letterSpacing: "0.0065em",
          color: "#000000",
          position: "relative",
        }}
      >
        {message}
      </Typography>

      <style>
        {`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </Box>
  );
};

export default Loader;
